import { Component, output } from '@angular/core';

@Component({
  standalone: true,
  imports: [],
  selector: 'app-google-login-button',
  template: `
    <button
      type="button"
      class="inline-flex w-full items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
      (click)="googleClick.emit()"
    >
      <svg class="mr-3 h-5 w-5" viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="#EA4335"
          d="M12 10.2v3.9h5.4c-.2 1.3-1.5 3.9-5.4 3.9-3.2 0-5.9-2.7-5.9-6s2.7-6 5.9-6c1.8 0 3 .8 3.7 1.5l2.5-2.4C16.7 3.6 14.6 2.8 12 2.8 6.9 2.8 2.8 6.9 2.8 12S6.9 21.2 12 21.2c6.1 0 9.1-4.3 9.1-6.6 0-.4 0-.8-.1-1.1H12Z"
        />
        <path
          fill="#34A853"
          d="M2.8 7.4 6 9.8c.9-1.8 2.8-3.1 6-3.1 1.8 0 3 .8 3.7 1.5l2.5-2.4C16.7 3.6 14.6 2.8 12 2.8 8.4 2.8 5.2 4.8 3.6 7.8Z"
        />
        <path
          fill="#FBBC05"
          d="M2.8 16.6 6.5 13.8c-.2-.6-.3-1.2-.3-1.8s.1-1.2.3-1.8L2.8 7.4C2.1 8.8 1.8 10.3 1.8 12s.4 3.2 1 4.6Z"
        />
        <path
          fill="#4285F4"
          d="M12 21.2c2.5 0 4.6-.8 6.2-2.3l-3-2.3c-.8.6-1.8 1-3.2 1-3.1 0-5-2.1-5.8-3.8l-3.6 2.8c1.5 3 4.7 4.6 8.4 4.6Z"
        />
      </svg>
      Continue with Google
    </button>
  `,
})
export class GoogleLoginButtonComponent {
  googleClick = output<void>();
}
